module.exports = __webpack_public_path__ + "img/nextPage2.4bed41ed.png";